export default {
  methods: {
    $nt: function (value, ...rest) {
      let ns = this.ns
      if (!ns) {
        ns = this.$options.name
      }
      const translateKey = `${ns}.${value}`
      return this.$t(translateKey, ...rest)
    }
  }
}
